/**
 * Tax label by visitor location. Prices unchanged.
 * ES peninsula/Baleares + non-EU → “IVA incluido”
 * Other EU (IP) or Canarias/Ceuta/Melilla (cart province) → “Sin IVA”
 */
(function () {
  if (window.__wod3dTaxGeoBooted) return;
  window.__wod3dTaxGeoBooted = true;

  const EU = new Set([
    'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU',
    'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'SE',
  ]);
  const STORAGE_KEY = 'wod3d_ip_country_v1';
  const EXCLUDED_NOTE = '[data-wod3d-tax-note="excluded"], [data-wod3d-tax-note="eu-silent"]';

  function isCanariasProvince(province) {
    const p = String(province || '').trim().toUpperCase();
    if (!p) return false;
    if (p === 'TF' || p === 'GC' || p === 'LP' || p === 'HZ') return true;
    return /CANAR|LAS PALMAS|TENERIFE|CEUTA|MELILLA/.test(p);
  }

  function shouldShowTaxIncluded(country, province) {
    const code = String(country || '').trim().toUpperCase();
    if (!code) return null;
    if (code === 'ES') {
      if (isCanariasProvince(province)) return false;
      return true;
    }
    if (EU.has(code)) return false;
    return true;
  }

  function apply(show) {
    if (show == null) return;
    document.documentElement.dataset.wod3dTaxIncluded = show ? '1' : '0';
    document.querySelectorAll('[data-wod3d-tax-note="claim"]').forEach((el) => {
      el.hidden = !show;
    });
    document.querySelectorAll(EXCLUDED_NOTE).forEach((el) => {
      el.hidden = !!show;
    });
  }

  function rootPath() {
    const root = window.Shopify?.routes?.root;
    return typeof root === 'string' && root ? root : '/';
  }

  async function detectCountryByIp() {
    try {
      const cached = sessionStorage.getItem(STORAGE_KEY);
      if (cached) return cached;
    } catch (_) {}

    try {
      const res = await fetch(`${rootPath()}browsing_context_suggestions.json`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!res.ok) return '';
      const data = await res.json();
      const country = String(
        data?.detected_values?.country?.handle ||
          data?.detected_values?.country?.iso_code ||
          data?.detected_values?.country ||
          ''
      )
        .trim()
        .toUpperCase();
      if (country) {
        try {
          sessionStorage.setItem(STORAGE_KEY, country);
        } catch (_) {}
      }
      return country;
    } catch (_) {
      return '';
    }
  }

  async function detectCartProvince() {
    const fromDom = document.documentElement.dataset.wod3dShipProvince;
    if (fromDom) return fromDom;
    try {
      const res = await fetch(`${rootPath()}cart.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!res.ok) return '';
      const cart = await res.json();
      const addr = cart?.shipping_address || {};
      return String(addr.province_code || addr.province || '').trim();
    } catch (_) {
      return '';
    }
  }

  async function refresh() {
    if (window.Shopify?.designMode) return;
    const [country, province] = await Promise.all([detectCountryByIp(), detectCartProvince()]);
    if (province) {
      document.documentElement.dataset.wod3dShipProvince = province;
    }
    apply(shouldShowTaxIncluded(country, province));
  }

  window.wod3dTaxGeo = { refresh, apply, shouldShowTaxIncluded, isCanariasProvince };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }

  document.addEventListener('cart:updated', refresh);
  document.addEventListener('cart-drawer:updated', refresh);

  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes || []) {
        if (!(node instanceof Element)) continue;
        if (
          node.matches?.('[data-wod3d-tax-note]') ||
          node.querySelector?.('[data-wod3d-tax-note]')
        ) {
          const flag = document.documentElement.dataset.wod3dTaxIncluded;
          if (flag === '1') apply(true);
          else if (flag === '0') apply(false);
          else refresh();
          return;
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
